import PATHS from './paths'

export const PULSE_LIST_PATHS = [PATHS.SCHEDULES, PATHS.TRIGGERS, PATHS.SKILLS]
export const PULSE_BROWSE_PATHS = [PATHS.PULSE, ...PULSE_LIST_PATHS]

export function isPulseListPath(pathname) {
  return PULSE_LIST_PATHS.includes(pathname)
}

export function isPulseBrowsePath(pathname) {
  return PULSE_BROWSE_PATHS.includes(pathname)
}
